<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1>FIDELITY CARD</h1></div>
            <div class="content content-full">
                <div class="title" v-if="this.personal_score">
                    {{$t("fidelity_card_accumulato")}} {{this.personal_score}} {{$t("punti")}}
                    <span class="red">*</span></div>
                <hr>

                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div v-if="this.promotion">
                              <div v-if="!(this.promotion.mask_locali & this.locale.id)" style="margin:30px;">
                                  <p class="red">
                                        <span>
                                            {{$t('fidelity_mask_locali_warning').replace("{NOME_LOCALE}", this.locale.nome_locale)}}
                                        </span>
                                  </p>
                                </div>
                                <div class="card" style="border:0;">
                                    <div class="card-body">
                                        <ul class="timeline">
                                            <li v-for="(soglia, i) in this.thresholds"
                                                :class="{'timeline-inverted': i%2}">
                                                <div class="timeline-badge badge-info"
                                                     :class="{'bg-gray': !personal_score || personal_score < soglia.soglia}">
                                                    {{soglia.soglia}}
                                                </div>
                                                <div class="timeline-panel">
                                                    <div class="timeline-heading">
                                                        <h4 class="timeline-title" :class="{'text-right':i%2}">
                                                            <i class="fa fa-gift"></i>
                                                            <inc-reward-name :reward="soglia" :type="promotion.tipo"/>
                                                        </h4>
                                                        <p :class="{'text-right': i%2}">
                                                            {{$t("fidelity_card_raccogli_1")}} {{soglia.soglia}}
                                                            {{$t("fidelity_card_raccogli_2")}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div style="margin:30px;">
                                    <p class="red">
                                        <span v-if="promotion.modalita === 1">
                                            {{$t('fidelity_card_punti_regola_1_1')}}<br/>
                                            {{$t('fidelity_card_punti_regola_1_2')}}<br/>
                                            {{$t('fidelity_card_punti_regola_1_3')}}<br/>
                                            {{$t('fidelity_card_punti_regola_1_4')}}
                                        </span>
                                        <span v-else-if="promotion.modalita === 2">
                                            {{$t('fidelity_card_punti_regola_2_1')}}<br/>
                                            {{$t('fidelity_card_punti_regola_2_2')}}<br/>
                                            {{$t('fidelity_card_punti_regola_2_3')}}<br/>
                                            {{$t('fidelity_card_punti_regola_2_4')}}
                                        </span>
                                    </p>
                                    <hr>
                                    <p v-if="!promotion.f_cumulabile" class="mt-2 mb-0">
                                        {{$t("fidelity_card_promozione_non_cumulabile")}}
                                    </p>
                                    <p v-if="!promotion.f_azzera_punti">
                                        {{$t("fidelity_card_punti_non_si_azzerano")}}
                                    </p>
                                    <span v-if="promotion.f_scadenza_premi">
                                        {{$t("fidelity_card_punti_azzerano_1")}}
                                        {{moment(promotion.data_scadenza_premi).diff(moment(promotion.al), 'days')}}
                                        {{$t("fidelity_card_punti_azzerano_2")}}
                                    </span>
                                </div>
                            </div>
                            <div class="text-center mt-2 f4" v-else>
                                <i>{{$t("fidelity_card_no_promozione")}}</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="this.personal_rewards" class="mt-3">
                <div class="header"><h1>{{$t("fidelity_card_premi_accumulati")}}</h1></div>
                <div class="content content-full" style="min-height: 200px;">
                    <div class="container">
                        <div class="row-sezione text-center">
                            <div v-if="this.personal_rewards.length">
                                <div class="blocchetto" v-for="(reward, i) in personal_rewards"
                                     :class="{'mt-0': !i}">
                                    {{$t("reward")}}:<br>
                                    <b class="f2">
                                        <inc-reward-name :reward="reward" :type="reward.tipo"/>
                                    </b><br>
                                    <span class="color">
                                        {{$t("valido_dal")}}
                                        {{moment(reward.data_inizio).format('DD/MM/YYYY')}}
                                        {{$t("al")}}
                                        {{moment(reward.data_scadenza).format('DD/MM/YYYY')}}
                                </span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="text-center mt-2 f4"><i>{{$t("fidelity_card_no_premi")}}</i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {getFidelityCard} from "../../api/restaurant";

import IncRewardName from './partials/IncRewardName';

export default {
    name: "Index",
    components: {IncRewardName},
    data() {
        return {
            fidelity_card: null
        };
    },
    created() {
        this.fetch();
    },
    computed: {
        thresholds: function () {
            if (this.promotion) {
                return this.promotion.soglie.sort((a, b) => {
                    if (a.soglia < b.soglia) {
                        return -1;
                    } else if (a.soglia > b.soglia) {
                        return 1;
                    }

                    return 0;
                })
            }

            return [];
        },
        promotion: function () {
            if (this.fidelity_card && this.fidelity_card.promozione) {
                return this.fidelity_card.promozione;
            }

            return null;
        },
        personal_score: function () {
            try {
                return this.fidelity_card.punteggio_personale;
            } catch (e) {
                return null;
            }
        },
        personal_rewards: function () {
            try {
                return this.fidelity_card.premi_personali
            } catch (e) {
                return null;
            }
        },
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('auth', {
            user: state => state
        })
    },
    watch: {
        language: function () {
            this.fetch();
        }
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getFidelityCard(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                email: this.user.email,
                api_key: this.user.api_key
            }).then((response) => {
                this.fidelity_card = response;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            });
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
